<template>
  <div ref="viewer"></div>
</template>

<script>
  import WebViewer from '@pdftron/pdfjs-express'

  export default {
    name: 'WebViewer',
    props: {
      fileData: { type: Object, default: () => ({}) }
    },
    mounted() {
      WebViewer(
        {
          path: this.pdfViewerPath // путь к зависимостям которые нужны для работы webViewer
        },
        this.$refs.viewer
      ).then((instance) => {
        this.webViewInstance = instance
        instance.UI.loadDocument(this.fileData.url, { extension: this.fileData.type })
      })
    },

    computed: {
      // Путь к зависимостям которые нужны для работы pdf ридера из public
      pdfViewerPath() {
        let basePath = `${this.$router.history.base}/pdfViewer`
        if (!window.location.host.includes('localhost')) {
          return basePath
        }
        // Случай для продакшена
        return basePath.replace('WebAppModeler/', '')
      }
    },

    watch: {
      fileData: function (fileData) {
        // Загрузить новый документ в случае если url изменился
        this.webViewInstance.loadDocument(fileData.url, { extension: fileData.type })
      }
    }
  }
</script>

<style scoped>
  div {
    width: 100%;
    height: 100vh;
  }
</style>
